import { CUBIC_BOT_NAMES } from '@/lib/constants';
import { isCodingAgentLogin } from '@/lib/inngest/functions/ensure-coding-agent-bot-seat/coding-agent-bot';

type ReviewThreadNode = {
  comments: {
    nodes: Array<{
      id: string;
    }>;
  };
};

type MappedComment = {
  githubCommentId?: string | null;
};

const DISPLAYED_CUBIC_LOGINS = new Set(
  [...CUBIC_BOT_NAMES, 'cubic[bot]', 'cubic'].map((login) => login.toLowerCase()),
);

export function isDisplayedCubicLogin(userLogin: string | null | undefined): boolean {
  return userLogin ? DISPLAYED_CUBIC_LOGINS.has(userLogin.toLowerCase()) : false;
}

export function isBotOrAgentLogin(userLogin: string | null | undefined): boolean {
  if (!userLogin) {
    return false;
  }

  const lower = userLogin.toLowerCase();
  return (
    isDisplayedCubicLogin(userLogin) || lower.endsWith('[bot]') || isCodingAgentLogin(userLogin)
  );
}

export function getMappedThreadFirstComment<T>(
  thread: ReviewThreadNode,
  commentsByNodeId: Map<string, T>,
): T | null {
  const firstCommentNode = thread.comments.nodes[0];
  if (!firstCommentNode) {
    return null;
  }

  return commentsByNodeId.get(firstCommentNode.id) ?? null;
}

export function getMappedThreadFirstGithubCommentId<T extends MappedComment>(
  thread: ReviewThreadNode,
  commentsByNodeId: Map<string, T>,
): string | null {
  const firstComment = getMappedThreadFirstComment(thread, commentsByNodeId);
  const githubCommentId = firstComment?.githubCommentId;

  return typeof githubCommentId === 'string' && githubCommentId.length > 0 ? githubCommentId : null;
}
